import React from "react";
import { motion } from "framer-motion";
import ProgressBar from "../components/ProgressBar";
import teacherImg from "../images/teacher.png";
import notTeacherImg from "../images/not_teacher.png";

const Step6 = () => {
  const student = JSON.parse(localStorage.getItem("student"));

  const handleSelect = async (value) => {
    if (!student) {
      alert("Student data not found. Please login again.");
      window.location.href = "/login";
      return;
    }

    // CASE 1: USER IS A TEACHER → lanjut Step7
    if (value === "teacher") {
      try {
        const response = await fetch(
           `http://localhost:3000/api/student-demography/${student.student_id}`,
          {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              job: "teacher",
              current_step: "7", // <--- TRACK STEP LANJUTAN
            }),
          }
        );

        if (!response.ok) {
          alert("Failed to update job");
          return;
        }

        // Update localStorage
        const updatedStudent = {
          ...student,
          job: "teacher",
          current_step: "7",
        };
        localStorage.setItem("student", JSON.stringify(updatedStudent));

        window.location.href = "/step7";

      } catch (err) {
        console.error("Error updating job:", err);
        alert("Server error");
      }

    }

    // CASE 2: USER NOT A TEACHER → under construction
    else {
      try {
        await fetch(
          `http://localhost:3000/student-demography/${student.student_id}`,
          {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              job: "not_teacher",
              current_step: "done", // <--- boleh diganti "dashboard"
            }),
          }
        );

        // Update localStorage
        const updatedStudent = {
          ...student,
          job: "not_teacher",
          current_step: "done",
        };
        localStorage.setItem("student", JSON.stringify(updatedStudent));
      } catch (err) {
        console.error("Error saving job:", err);
      }

      window.location.href = "/UnderConstruction";
    }
  };

  return (
    <div className="relative min-h-screen flex flex-col items-center bg-gradient-to-b from-blue-900 via-blue-700 to-blue-400 text-white px-4 overflow-hidden">

      {/* Progress Bar */}
      <div className="w-full max-w-lg mt-6 z-20">
        <ProgressBar step={6} />
      </div>

      {/* Title */}
      <h1 
		className="text-3xl md:text-4xl font-extrabold mt-10 text-yellow-300 text-center drop-shadow-md">
        
		WHAT DO YOU DO?
      </h1>

      {/* CHOICE BUTTONS */}
      <div className="flex flex-col md:flex-row gap-4 mt-10 z-10">

        {/* TEACHER BUTTON */}
        <motion.div
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.96 }}
          onClick={() => handleSelect("teacher")}
          className="cursor-pointer border-2 border-yellow-300 rounded-3xl p-6 w-72 md:w-96 flex flex-col items-center shadow-lg bg-transparent"
        >
          <img
            src={teacherImg}
            alt="Teacher"
            className="w-56 h-56 md:w-64 md:h-64 object-cover mb-4 rounded-xl"
          />
          <p className="text-xl font-bold text-yellow-300">I am a Teacher</p>
        </motion.div>

        {/* NOT TEACHER BUTTON */}
        <motion.div
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.96 }}
          onClick={() => handleSelect("not_teacher")}
          className="cursor-pointer border-2 border-yellow-300 rounded-3xl p-6 w-72 md:w-96 flex flex-col items-center shadow-lg bg-transparent"
        >
          <img
            src={notTeacherImg}
            alt="Not Teacher"
            className="w-56 h-56 md:w-64 md:h-64 object-cover mb-4 rounded-xl"
          />
          <p className="text-xl font-bold text-yellow-300">I am not a Teacher</p>
        </motion.div>

      </div>

      {/* Footer */}
      <p className="absolute bottom-4 text-blue-200 text-xs">
        © 2025 Universitas Terbuka
      </p>
    </div>
  );
};

export default Step6;
